import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnDestroy, ViewContainerRef } from '@angular/core';
import { DataDictionaryApi } from '../../../api/data-dictionary-api';
import { util } from '../../../classes/util';
import { InputConverter } from '../../../inputConverter';
import { FilterService } from '../../../services/filter.service';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { isQueryableMapCoreLayer } from '../../../types';
import { BaseComponent } from '../../base.component';
var shortWait = 10;
var joinTableAlias = 'JOINTABLE';
var baseTableAlias = 'TBL';
/** Join Filter Component */
var JoinFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(JoinFilterComponent, _super);
    function JoinFilterComponent(_vcr, changeDetectorRef, layerService, filterService, toSqlStringService, dataDictionaryApi) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.layerService = layerService;
        _this.filterService = filterService;
        _this.toSqlStringService = toSqlStringService;
        _this.dataDictionaryApi = dataDictionaryApi;
        _this.tableColumns = [];
        _this.tableColumnsDisplay = [];
        _this.disableObj = false;
        _this.updateQuery = function (query) {
            _this._outsideUpdate = true;
            _this._query = query;
        };
        _this._outsideUpdate = false;
        _this.layerColumns = [];
        _this._summaryItemsString = '';
        _this.hideExport = false;
        _this.selectedJoinRecord = null;
        _this._workingQuery = _this.filterService.getEmptyQuery();
        _this.exportEnabled = false;
        _this.finalizeQuery = function () {
            _this.query = _this.filterService.getFinalizedQuery(_this.workingQuery);
        };
        _this.updateLayerOnApply = true;
        _this.ondone = new EventEmitter();
        _this.workingQueryChange = new EventEmitter();
        _this.exportOptionChange = new EventEmitter();
        _this.onapply = new EventEmitter();
        _this.refreshSubqueries = util.debounce(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshSubqueriesWork()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, shortWait);
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('onapply', _this.onapply);
        _this.registerEvent('workingQueryChange', _this.workingQueryChange);
        _this.registerEvent('exportOptionChange', _this.exportOptionChange);
        _this.setOperatorOptions();
        return _this;
    }
    Object.defineProperty(JoinFilterComponent.prototype, "layerId", {
        get: function () { return this._layerId; },
        set: function (layerId) {
            this.setLayer(layerId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JoinFilterComponent.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (inputQuery) {
            this._query = inputQuery;
            this.execQuery();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JoinFilterComponent.prototype, "layerRef", {
        get: function () {
            return this._layerRef;
        },
        set: function (value) {
            this._layerRef = value;
        },
        enumerable: true,
        configurable: true
    });
    JoinFilterComponent.prototype.updateWorkingSql = function (summaryString) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.summaryItemsString = summaryString;
                        return [4 /*yield*/, this.populateWorkingSql()];
                    case 1:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(JoinFilterComponent.prototype, "summaryItemsString", {
        get: function () {
            return this._summaryItemsString;
        },
        set: function (inputSummary) {
            this._summaryItemsString = inputSummary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JoinFilterComponent.prototype, "primaryLayerRMSKeys", {
        get: function () {
            return this._primaryLayerRMSKeys;
        },
        set: function (inputKeys) {
            this._primaryLayerRMSKeys = inputKeys;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JoinFilterComponent.prototype, "workingQuery", {
        get: function () {
            return this._workingQuery;
        },
        set: function (inputQuery) {
            this._workingQuery = inputQuery;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JoinFilterComponent.prototype, "hideExportSection", {
        get: function () {
            return this.hideExport;
        },
        set: function (value) {
            this.hideExport = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JoinFilterComponent.prototype, "andOr", {
        get: function () {
            return this.workingQuery.joinTableQuery && this.workingQuery.joinTableQuery.operator === 'OR' ? 'or' : 'and';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JoinFilterComponent.prototype, "showFilter", {
        get: function () {
            return this.layerColumns.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    JoinFilterComponent.prototype.ngOnDestroy = function () {
        this.reset();
    };
    JoinFilterComponent.prototype.reset = function () {
        this.selectedJoinRecord = null;
        this.joinRecords = [];
        this.exportEnabled = false;
    };
    JoinFilterComponent.prototype.execQuery = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.populateLayerDataPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.populateLayerDataPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.refreshSubqueries()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.populateJoinRecords = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.layerService.getTableRMSKeys()];
                    case 1:
                        _a.joinRecords = _b.sent();
                        if (!(this.query && this.query.joinRecord && this.query.joinRecord.tableId && this.query.joinRecord.tableId > 0)) return [3 /*break*/, 3];
                        this.selectedJoinRecord = this.joinRecords.filter(function (x) { return x.tableId === _this.query.joinRecord.tableId; })[0];
                        return [4 /*yield*/, this.populateSelectedJoinedTable(this.selectedJoinRecord.tableId)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.setLayer = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._layerId = layerId;
                        this.workingSql = '';
                        this.layerRef = undefined;
                        this.table = null;
                        this.layerColumns.length = 0;
                        this.tableColumnsDisplay.length = 0;
                        return [4 /*yield*/, this.populateLayerData()];
                    case 1:
                        _a.sent();
                        this.populateLayerDataPromise = this.populateJoinRecords();
                        return [4 /*yield*/, this.populateLayerDataPromise];
                    case 2:
                        _a.sent();
                        this.populateWorkingQueryFromQuery();
                        this.isJoinRecordSelected();
                        return [4 /*yield*/, this.refreshSubqueries()];
                    case 3:
                        _a.sent();
                        this.setExportColumns();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.resetSubQueries = function () {
        this.workingQuery.joinTableQuery.subqueries = [{ subqueries: [], operator: 'AND' }];
        this.filterService.clearValuesIfNeeded(this.workingQuery.joinTableQuery.subqueries);
        this.workingQuery.joinTableQuery.subqueries = this.filterService.populateWorkingSubqueryDisplayProperties(this.workingQuery.joinTableQuery.subqueries, this.layerColumns);
    };
    JoinFilterComponent.prototype.remove = function (i) {
        this.workingQuery.joinTableQuery.subqueries.splice(i, 1);
        this.refreshSubqueries();
    };
    JoinFilterComponent.prototype.setAll = function () {
        this.workingQuery.joinTableQuery.operator = 'AND';
        this.refreshSubqueries();
    };
    JoinFilterComponent.prototype.setAny = function () {
        this.workingQuery.joinTableQuery.operator = 'OR';
        this.refreshSubqueries();
    };
    JoinFilterComponent.prototype.setOperatorOptions = function () {
        this.operatorOptions = this.toSqlStringService.getOperatorOptions();
    };
    JoinFilterComponent.prototype.joinRecordChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tableId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof this.selectedJoinRecord === 'string') {
                            this.selectedJoinRecord = null;
                        }
                        if (!this.selectedJoinRecord) return [3 /*break*/, 2];
                        tableId = this.selectedJoinRecord.tableId;
                        return [4 /*yield*/, this.populateSelectedJoinedTable(tableId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.resetExportColumns();
                        this.workingQuery.joinRecord = this.selectedJoinRecord;
                        this.workingQuery.primaryLayerRMSKeys = this.primaryLayerRMSKeys;
                        this.resetSubQueries();
                        this.isJoinRecordSelected();
                        return [4 /*yield*/, this.populateWorkingSql()];
                    case 3:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        this.emitWorkingQuery();
                        return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.populateSelectedJoinedTable = function (tableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, _b, dataDictionaryColumns, _loop_1, _c, _d, column;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, this.layerService.getTableColumns(tableId)];
                    case 1:
                        _b.selectedTable = _e.sent();
                        this.tableColumns = this.selectedTable.columns;
                        this.tableColumnsDisplay = this.tableColumns.sort(function (a, b) { return (a.name > b.name) ? 1 : -1; });
                        this.selectedJoinRecord.isOffsetNumber = this.filterService.offSetIsNumber(this.selectedJoinRecord.offsetEndColName, this.tableColumns);
                        if (!(this.selectedTable && this.selectedTable.metaTable && this.tableColumns)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dataDictionaryApi.getColumnsWithDomainValuesByMetaTableId(this.selectedTable.metaTable.id)];
                    case 2:
                        dataDictionaryColumns = _e.sent();
                        if (dataDictionaryColumns) {
                            _loop_1 = function (column) {
                                var matchingColumn = dataDictionaryColumns.find(function (c) { return c.columnName.toLowerCase().trim() === column.name.toLowerCase().trim(); });
                                if (matchingColumn && matchingColumn.domainValues && matchingColumn.domainValues.length) {
                                    column.domainValues = matchingColumn.domainValues;
                                }
                            };
                            try {
                                for (_c = tslib_1.__values(this.tableColumns), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    column = _d.value;
                                    _loop_1(column);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        _e.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.applyFilterChangeToLayer = function () {
        this.ondone.emit({ layerId: this.layerId, sql: this.workingSql, query: this.query });
    };
    JoinFilterComponent.prototype.addBottomSubqueryIfNeeded = function () {
        if (this.workingQuery.joinTableQuery.subqueries) {
            var addWorkingSubquery = this.workingQuery.joinTableQuery.subqueries.length === 0;
            if (!addWorkingSubquery) {
                var lastSubquery = this.workingQuery.joinTableQuery.subqueries[this.workingQuery.joinTableQuery.subqueries.length - 1];
                addWorkingSubquery = this.toSqlStringService.queryConditionIsValid(lastSubquery);
            }
            if (addWorkingSubquery) {
                this.workingQuery.joinTableQuery.subqueries.push({ field: '', operator: '=', value: null });
            }
        }
    };
    JoinFilterComponent.prototype.populateLayerData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_2, _b, layers, tables, _c, _d, layerColumn;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.layerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.filterService.getLayerData(this.layerId)];
                    case 1:
                        layers = _e.sent();
                        if (layers.length > 0) {
                            this.layerRef = layers[0];
                            tables = this.layerRef.tables;
                            this.table = tables.sort(function (a, b) { return a.geometryType.localeCompare(b.geometryType); })[0];
                            if (this.layerRef.queryJSON) {
                                this.layerQuery = JSON.parse(this.layerRef.queryJSON);
                            }
                            else {
                                this.layerQuery = {};
                            }
                            this.layerColumns.length = 0;
                            (_a = this.layerColumns).push.apply(_a, tslib_1.__spread(layers[0].columns));
                            try {
                                for (_c = tslib_1.__values(this.layerColumns), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    layerColumn = _d.value;
                                    layerColumn.alias = layerColumn.alias.toLowerCase();
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            return [2 /*return*/, this.layerColumns];
                        }
                        _e.label = 2;
                    case 2: return [2 /*return*/, []];
                }
            });
        });
    };
    JoinFilterComponent.prototype.populateWorkingQueryFromQuery = function () {
        if (this.query) {
            this.workingQuery = this.filterService.populateWorkingQueryFromQuery(this.query, this.tableColumns);
            this.workingQuery.primaryLayerRMSKeys = this.primaryLayerRMSKeys;
        }
    };
    JoinFilterComponent.prototype.populateWorkingSql = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.table) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.filterService.populateWorkingSql(this.layerQuery, this.workingQuery, this.table, this.layerColumns)];
                    case 1:
                        _a.workingSql = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.refreshSubqueriesWork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var populatePromises_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filterService.clearValuesIfNeeded(this.workingQuery.joinTableQuery.subqueries);
                        this.workingQuery.joinTableQuery.subqueries = this.filterService.populateWorkingSubqueryDisplayProperties(this.workingQuery.joinTableQuery.subqueries, this.layerColumns);
                        return [4 /*yield*/, this.populateWorkingSql()];
                    case 1:
                        _a.sent();
                        if (!(this.selectedJoinRecord && this.workingQuery.joinTableQuery.subqueries && this.workingQuery.joinTableQuery.subqueries.length)) return [3 /*break*/, 3];
                        populatePromises_1 = [];
                        this.workingQuery.joinTableQuery.subqueries.forEach(function (sq, i) {
                            if (!sq.distinctValues) {
                                populatePromises_1.push(_this.filterService.populateDistinctValues(_this.selectedJoinRecord.tableId, sq, _this.layerQuery.joinTableQuery, _this.workingQuery.joinTableQuery, _this.tableColumns, i, true, _this.esriLayers && _this.esriLayers.length ? _this.esriLayers[0].mapcoreProps.isPETL : null));
                            }
                        });
                        return [4 /*yield*/, Promise.all(populatePromises_1)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.addBottomSubqueryIfNeeded();
                        this.showSelectMenu();
                        this.changeDetectorRef.detectChanges();
                        this.emitWorkingQuery();
                        return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.toggleShowSql = function () {
        this.showSQL = !this.showSQL;
    };
    JoinFilterComponent.prototype.emitWorkingQuery = function () {
        if (!this._outsideUpdate) {
            this.workingQueryChange.emit({ workingQuery: this.workingQuery, joinColumns: this.tableColumns });
        }
        this._outsideUpdate = false;
        this.changeDetectorRef.detectChanges();
    };
    JoinFilterComponent.prototype.showSelectMenu = function () {
        var addWorkingSubquery = false;
        if (this.workingQuery && this.workingQuery.joinTableQuery && this.workingQuery.joinTableQuery.subqueries) {
            addWorkingSubquery = this.workingQuery.joinTableQuery.subqueries.length === 0;
            if (!addWorkingSubquery) {
                var lastSubquery = this.workingQuery.joinTableQuery.subqueries[0];
                addWorkingSubquery = this.toSqlStringService.queryConditionIsValid(lastSubquery);
            }
        }
        this.disableSelectMenu = addWorkingSubquery;
    };
    JoinFilterComponent.prototype.layerData = function (layerRef) {
        var mcWindow = document.getElementById('mcWindow');
        var titleText = 'Filter';
        if (layerRef) {
            titleText = "Filter: " + layerRef.name;
        }
        mcWindow.title = titleText;
    };
    JoinFilterComponent.prototype.onValueChange = function (_event) {
        var _this = this;
        this.changeDetectorRef.detectChanges();
        setTimeout(function () { _this.refreshSubqueries(); }, shortWait);
    };
    JoinFilterComponent.prototype.setExportColumns = function () {
        this.exportOptionChange.emit({
            exportEnabled: this.exportEnabled,
            layerColumns: this.layerColumns,
            exportJoinColumns: this.exportJoinColumns
        });
        this.changeDetectorRef.detectChanges();
    };
    JoinFilterComponent.prototype.setAllExportColumns = function () {
        this.exportJoinColumns = this.tableColumnsDisplay.map(function (b) { return b.name; });
        this.setExportColumns();
    };
    JoinFilterComponent.prototype.resetExportColumns = function () {
        this.exportJoinColumns = [];
        this.setExportColumns();
    };
    JoinFilterComponent.prototype.onFieldChange = function (field, subquery, subqueryIndex) {
        subquery.field = field;
        this.selectedFilterColumn(subquery, subqueryIndex);
    };
    JoinFilterComponent.prototype.selectedFilterColumn = function (subquery, subqueryIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subquery.multiValue = null;
                        subquery.value = null;
                        this.changeDetectorRef.detectChanges();
                        return [4 /*yield*/, this.filterService.populateDistinctValues(this.selectedJoinRecord.tableId, subquery, this.layerQuery, this.workingQuery, this.tableColumns, subqueryIndex, true, this.esriLayers && this.esriLayers.length ? this.esriLayers[0].mapcoreProps.isPETL : null)];
                    case 1:
                        subquery = _a.sent();
                        this.refreshSubqueries();
                        return [2 /*return*/];
                }
            });
        });
    };
    JoinFilterComponent.prototype.applyFilter = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, esriLayer;
            return tslib_1.__generator(this, function (_a) {
                this.finalizeQuery();
                data = {
                    layerId: this.layerId,
                    sql: this.workingSql,
                    query: this.query,
                    joinColumns: null,
                    exportJoinFilterParams: null,
                    exportEnabled: undefined,
                    exportJoinColumns: null
                };
                this.ondone.emit(data);
                if (this.updateLayerOnApply) {
                    data.joinColumns = this.tableColumns;
                    data.exportJoinFilterParams = { exportEnabled: this.exportEnabled };
                    if (this.exportEnabled) {
                        data.exportEnabled = this.exportEnabled;
                        data.exportJoinColumns = this.exportJoinColumns;
                    }
                    this.onapply.emit({ id: data.layerId.toString(), data: data });
                    esriLayer = this.layerService.getEsriLayerByUniqueId(this.esriLayerId);
                    if (esriLayer && data && isQueryableMapCoreLayer(esriLayer)) {
                        esriLayer.mapcoreProps.filter = data.sql;
                        esriLayer.mapcoreProps.query = data.query;
                        esriLayer.mapcoreProps.joinColumns = data.joinColumns;
                        esriLayer.mapcoreProps.exportJoinFilterParams = { exportEnabled: this.exportEnabled };
                        if (esriLayer.mapcoreProps.exportJoinFilterParams) {
                            esriLayer.mapcoreProps.exportJoinFilterParams.exportEnabled = this.exportEnabled;
                            esriLayer.mapcoreProps.exportJoinFilterParams.exportJoinColumns = this.exportJoinColumns;
                        }
                        this.layerService.updateLayerFilter(esriLayer, data.query);
                        this.onapply.emit({ esriLayer: esriLayer });
                    }
                    else {
                        this.onapply.emit(null);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    JoinFilterComponent.prototype.exportButtonChanged = function (e) {
        this.exportEnabled = e.target.checked;
        if (!this.exportEnabled) {
            this.exportJoinColumns = [];
        }
        this.setExportColumns();
    };
    JoinFilterComponent.prototype.buildExportJoinQuery = function () {
        var sql = '';
        var combinedColumns = [];
        this.layerColumns.forEach(function (column) {
            combinedColumns.push(baseTableAlias + "." + column.name + " as " + column.name);
        });
        this.exportJoinColumns.forEach(function (column) {
            combinedColumns.push(joinTableAlias + "." + column.name + " as " + column.name + "_1");
        });
        if (this.workingQuery.subqueries.values !== null) {
            sql = "(Select * from " + this.table.owner + "." + this.table.name + " Where " + this.toSqlStringService.getSql(this.workingQuery) + ")";
        }
        var sqlQuery = "Select " + combinedColumns.join() + " from " + sql + " " + baseTableAlias;
        var joinSql = this.toSqlStringService.getJoinFilter(this.query, baseTableAlias, joinTableAlias);
        sqlQuery += joinSql;
        return sqlQuery;
    };
    JoinFilterComponent.prototype.isJoinRecordSelected = function () {
        this.disableObj = (typeof this.selectedJoinRecord === 'string') || this.selectedJoinRecord === null || this.selectedJoinRecord === undefined;
    };
    JoinFilterComponent.prototype.cancel = function () {
        this.ondone.emit(null);
    };
    JoinFilterComponent.prototype.setFilter = function (layerId, esriLayerId, layerColumns, query) {
        this._layerId = layerId;
        this.esriLayerId = esriLayerId;
        this.layerColumns = layerColumns;
        this._query = query;
        this._outsideUpdate = true;
        this.setLayer(layerId);
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], JoinFilterComponent.prototype, "updateLayerOnApply", void 0);
    return JoinFilterComponent;
}(BaseComponent));
export { JoinFilterComponent };
